<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Редактировать страницу</strong>
                </CCardHeader>
                <CCardBody>
                    <AdsCampaignTabLinks :campaignId="adsCampaign.id" />
                    <CForm>
                        <CRow form class="form-group" style="margin-top: 20px">
                            <CCol tag="label" class="col-form-label" sm="3">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="adsCampaign.enabled"
                                />
                            </CCol>
                        </CRow>

                        <CInput
                            v-model="adsCampaign.name"
                            horizontal
                            label="Название"
                            placeholder="Введите название"
                        />

                        <CInput
                            v-model="adsCampaign.url"
                            horizontal
                            label="Ссылка страницы"
                            placeholder="Введите ссылку на страницу"
                        />
                    </CForm>
                </CCardBody>

                <CCardFooter>
                    <CButton color="primary" class="mr-3" @click="save">Сохранить</CButton>
                    <CButton color="light" class="mr-3" @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>

export default {
    name: 'CreateAdsCampaign',
    data() {
        return {
            adsCampaign: {
                name: '',
                title: '',
                description: '',
                footer_description: '',
                block: false,
                button_name: '',
                button_color: '',
                button_url: '',
                url: '',
                picture: '',
                enabled: false,
            },
            editor: null,
            footerEditor: null,
            selectedPicture: null,
        };
    },
    mounted() {},
    methods: {
            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },
        async save() {
            try {
                if (!this.adsCampaign.name) {
                    this.$root.$emit('showError', 'Введите название.');
                    return;
                }

                const {data} = await this.axios.post(`/ads-campaigns`, this.adsCampaign);
                this.$router.push(`/ads-campaigns/${data.id}/edit`)
            } catch (error) {
                console.log(error);
                this.$root.$emit('showError', 'Ошибка сохранения.');
            }
        },
        goBack() {
            this.$router.push({ path: `/ads-campaigns` });
        },
    },
};
</script>

<style>
</style>
